import DeviceData from 'Faster/model/DeviceData';

class DeviceDataJSON {
  public readonly platform?: string;
  public readonly system?: string;
  public readonly systemVersion?: string;
  public readonly manufacturer?: string;
  public readonly deviceModel?: string;
  public readonly appVersion?: string;
  public readonly sdkVersion?: string;
  public readonly vendorId?: string;
  public readonly advertisingId?: string;
  public readonly pushToken?: string;
  public readonly cloudId?: string;
  public readonly carrierId?: string;
  public readonly timezone?: string;
  public readonly language?: string;
  public readonly isNewInstall?: boolean;
  public readonly properties?: string;
}

class DeviceDataJsonTransformer {
  public static toJSON(deviceData: DeviceData): DeviceDataJSON {
    return Object.assign({}, deviceData, {
      properties: JSON.stringify(deviceData.properties),
    });
  }

  public static fromJSON(json: DeviceDataJSON): DeviceData {
    const device: object = Object.create(DeviceData.prototype);
    return Object.assign(device, json, {
      properties: JSON.parse(json.properties),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static reviver(key: string, value: any): any {
    const isRootLevel = key === '';
    return isRootLevel ? DeviceDataJsonTransformer.fromJSON(value) : value;
  }
}

export default DeviceDataJsonTransformer;
